/**
 * Copyright (C) 2009 Fundación Centro Cultural Colombo Americano de Cali.
 *
 * Este archivo es parte de SOFI: "Software Organizacional Fácil e Inteligente".
 *
 * Este programa es software comercial: está prohibida la venta, distribución y modificación de
 * SOFI sin la autorización de la Fundacion Centro Cultural Colombo Americano de Cali.
 *
 * Este programa fue registrado bajo las leyes de registro mercantil y ley de derechos de autor en
 * la SIC: "Superintendencia de Industria y Comercio".
 *
 * Cualquier duda o información acerca del programa se debe enviar a info@colomboamericano.edu.co.
 */

/**
 * Constants that represent actions to execute.
 *
 * @author Daniel Mejia
 * @file constants.js
 */

export const STORE_NAME = 'global';
export const FETCHING_DATA = 'fetchingData';
export const FETCHING_ERROR = 'fetchingError';
export const RESET_STORE = 'RESET_STORE';
export const SET_ERROR = 'SET_ERROR';
